import { BlogPost } from "@/types/blog";
import { content } from "./content";
import fuehrung2026Hero from "@/assets/blog/fuehrung-2026-haltung-empathie.webp";

export const fuehrung2026HaltungEmpathiePost: BlogPost = {
  title: "Führung im Jahr 2026",
  metaTitle: "Führung 2026: Haltung & Empathie statt Kontrolle",
  subtitle: "Haltung, Empathie und innere Reife statt Kontrolle",
  excerpt: "Was gute Führungskräfte heute wirklich auszeichnet. Psychologisch fundiert, ruhig und praxisnah. Führung als innere Haltung statt Methode.",
  metaDescription: "Was gute Führungskräfte heute wirklich auszeichnet. Psychologisch fundiert, ruhig und praxisnah. Führung als innere Haltung statt Methode.",
  date: "12.02.2026",
  lastUpdated: "15.02.2026",
  slug: "fuehrung-2026-haltung-empathie",
  imageUrl: fuehrung2026Hero,
  category: "Führung",
  tags: ["Führung", "Empathie", "Psychologische Sicherheit", "Haltung", "Emotionale Intelligenz", "Selbstführung"],
  content,
  readingTime: 8
};
